import { render, staticRenderFns } from "./Changepass.vue?vue&type=template&id=0e7e6e9c"
import script from "./Changepass.vue?vue&type=script&lang=js"
export * from "./Changepass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports